import $ from 'jquery';
import { setLanguage } from '~/js/services/i18n';


const languageSwitcher = function (options) {
    let o, m, internal, elements, fn, handlers;


    o = $.extend({
        $e: null,
        selector: ''
    }, options);


    m = languageSwitcher.markup;


    internal = {
        $e: o.$e || $(o.selector)
    };


    elements = {
        control: internal.$e.find(`.${m.CONTROL}`),
        menuItems: internal.$e.find(`.${m.MENU_ITEM}`)
    };


    fn = {
        init () {
            elements.control.on('click', handlers.controlClick);
            elements.menuItems.on('click', handlers.menuItemClick);
        },
        toggleMenu () {
            internal.$e.toggleClass(m.OPEN);
        }
    };


    handlers = {
        controlClick () {
            fn.toggleMenu();
        },
        menuItemClick () {
            setLanguage($(this).data('lang')).then(function () {
                window.location.reload();
            });
        }
    };


    fn.init();
};


languageSwitcher.markup = {
    // dom selector
    CONTAINER: 'language-switcher',
    CONTROL: 'language-switcher__control',
    MENU_ITEM: 'language-switcher__menu-item',

    // states
    OPEN: 'state-open'
};


export default languageSwitcher;



// WEBPACK FOOTER //
// ./assets/js/components/language-switcher.js